
import type { BaseErrorResponse, GetLeaderboardListRes, GetLeaderboardRes } from './data-contracts';
import type { RequestParams } from './http-client';
import { HttpClient } from './http-client';


export default function useLeaderboard() {
  class Leaderboard<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Leaderboard
     * @name LeaderboardControllerGetLeaderboardList
     * @summary Returns the list of messages from the queue
     * @request GET:/api3/leaderboard/{collectionId}
     * @secure
     * @response `200` `GetLeaderboardListRes`
     * @response `400` `BaseErrorResponse`
     */
    leaderboardControllerGetLeaderboardList = (collectionId: number, params: RequestParams = {}) =>
      this.request<GetLeaderboardListRes, BaseErrorResponse>({
        path: `/api3/leaderboard/${collectionId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Leaderboard
     * @name LeaderboardControllerGetLeaderboard
     * @summary Returns leaderboard data
     * @request GET:/api3/leaderboard/{leaderboardId}/items
     * @secure
     * @response `200` `GetLeaderboardRes`
     * @response `400` `BaseErrorResponse`
     */
    leaderboardControllerGetLeaderboard = (leaderboardId: number, params: RequestParams = {}) =>
      this.request<GetLeaderboardRes, BaseErrorResponse>({
        path: `/api3/leaderboard/${leaderboardId}/items`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new Leaderboard();
}
